/* eslint-disable react-hooks/exhaustive-deps */
import { Outlet } from "react-router-dom";
import { Wrapper } from "./styles";
import Header from "components/Organisms/Header";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "components/Organisms/Footer";
import dayjs from "dayjs";
import { useDisconnect } from "@web3modal/ethers/react";
export default function LayoutMain() {
  const { disconnect } = useDisconnect();
  useEffect(() => {
    AOS.init({
      duration: 1000,
      delay: 200,
    });
    const handleWheel = (event) => {
      if (document.activeElement.tagName === "INPUT" && document.activeElement.type === "number") {
        event.preventDefault();
      }
    };
    document.addEventListener("wheel", handleWheel, { passive: false });
    // CHECK EXPIRED
    const expired = localStorage.getItem('expired');
    if (dayjs(expired).isBefore(dayjs())) {
      disconnect();
      localStorage.removeItem('user');
      localStorage.removeItem('expired');
      window.location.reload();
    }
    return () => {
      document.removeEventListener("wheel", handleWheel);
    };
  }, []);
  return (
    <>
      <Header />
      <Wrapper>
        <Outlet />
      </Wrapper>
      <Footer />
    </>
  );
}
